import MessageModal from "../../component/MessageModal";

const PaymentFail = () => {
  return <MessageModal message="Payment Fail" />;
};

export default PaymentFail;
